import { FC, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { handleCompanyUrl } from 'utils/organizationUtils';

const GithubAuth: FC = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const {
    AppStore: { githubAuthConnected },
    notificationStore: { openNotification },
  } = useStore();

  useEffect(() => {
    if (location.search) {
      githubRequest.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const githubRequest = useMutation(() => githubAuthConnected(location.search), {
    onSuccess: (data: any) => {
      if (data) {
        history.push(handleCompanyUrl('/apps/github'));
      } else {
        history.push(handleCompanyUrl('/dashboard'));
      }
    },
    onError: ({ message }: Error) => openNotification('error', message ? message : 'Something went wrong'),
  });
  useAppPreloader(githubRequest.isLoading);
  return <></>;
});

export default GithubAuth;
